export interface SafeJob {
  id: string;
  title: string;
  company: string;
  location: string;
  salary: string;
  type: string;
  description: string;
  tags: string[];
  matchingSkills: string[];
}

export const safeJobs: SafeJob[] = [
  {
    id: '1',
    title: 'Customer Support Associate',
    company: 'ConnectNow Solutions',
    location: 'Remote',
    salary: '$22/hr',
    type: 'Full-time',
    description: 'Great match for your communication skills. Help customers and grow your career.',
    tags: ['Remote', 'Perfect Match', 'Great Benefits'],
    matchingSkills: ['Communication', 'Problem Solving', 'Customer Service'],
  },
  {
    id: '2',
    title: 'Medical Scheduler',
    company: 'Detroit Health Partners',
    location: 'Detroit, MI',
    salary: '$19-$21/hr',
    type: 'Full-time',
    description: 'Flexible hours, great for multitaskers. Coordinate appointments and support patients.',
    tags: ['Flexible Hours', 'Perfect Match', 'Local'],
    matchingSkills: ['Organization', 'Scheduling', 'Communication'],
  },
  {
    id: '3',
    title: 'Office Assistant (Entry Level)',
    company: 'Metro Business Center',
    location: 'Detroit, MI',
    salary: '$17/hr',
    type: 'Full-time',
    description: 'No experience required. Perfect for growing your admin skills with supportive team.',
    tags: ['Entry Level', 'No Experience Required', 'Training Provided'],
    matchingSkills: ['Microsoft Office', 'Organization', 'Attention to Detail'],
  },
  {
    id: '4',
    title: 'Retail Associate',
    company: 'FreshMart',
    location: 'Detroit, MI',
    salary: '$16/hr',
    type: 'Part-time',
    description: 'Part-time available. Build customer service skills in a friendly environment.',
    tags: ['Part-time Available', 'Great for Beginners', 'Employee Discount'],
    matchingSkills: ['Customer Service', 'Teamwork', 'Cash Handling'],
  },
  {
    id: '5',
    title: 'Data Entry Clerk',
    company: 'DataPro Services',
    location: 'Remote',
    salary: '$18/hr',
    type: 'Full-time',
    description: 'Remote work with training provided. Attention to detail and accuracy are valued.',
    tags: ['Remote', 'Training Provided', 'Perfect Match'],
    matchingSkills: ['Typing', 'Attention to Detail', 'Microsoft Excel'],
  },
  {
    id: '6',
    title: 'Warehouse Associate',
    company: 'Detroit Logistics Co',
    location: 'Detroit, MI',
    salary: '$20/hr',
    type: 'Full-time',
    description: 'Benefits included with advancement opportunities. Be part of a growing team.',
    tags: ['Benefits Included', 'Advancement Opportunities', 'Local'],
    matchingSkills: ['Physical Stamina', 'Teamwork', 'Safety Awareness'],
  },
  {
    id: '7',
    title: 'Receptionist',
    company: 'Professional Services Group',
    location: 'Hybrid',
    salary: '$18/hr',
    type: 'Full-time',
    description: 'Hybrid schedule available. Greet clients and manage front desk operations.',
    tags: ['Hybrid', 'Professional Environment', 'Growth Potential'],
    matchingSkills: ['Communication', 'Phone Etiquette', 'Scheduling'],
  },
  {
    id: '8',
    title: 'Food Service Worker',
    company: 'Campus Dining Services',
    location: 'Detroit, MI',
    salary: '$15/hr',
    type: 'Part-time',
    description: 'Flexible student-friendly hours. Great starter position with meal benefits.',
    tags: ['Student Friendly', 'Flexible Hours', 'Meal Benefits'],
    matchingSkills: ['Customer Service', 'Teamwork', 'Food Safety'],
  },
  {
    id: '9',
    title: 'Junior Marketing Coordinator',
    company: 'Creative Agency Detroit',
    location: 'Hybrid',
    salary: '$45k-$55k/yr',
    type: 'Full-time',
    description: 'Support marketing campaigns and social media efforts. Great opportunity to learn digital marketing.',
    tags: ['Marketing', 'Creative Environment', 'Career Growth'],
    matchingSkills: ['Social Media', 'Content Creation', 'Communication'],
  },
  {
    id: '10',
    title: 'Teaching Assistant',
    company: 'Detroit Public Schools',
    location: 'Detroit, MI',
    salary: '$17-$19/hr',
    type: 'Full-time',
    description: 'Support classroom teachers and help students succeed. Perfect for those passionate about education.',
    tags: ['Education', 'Rewarding Work', 'School Benefits'],
    matchingSkills: ['Patience', 'Communication', 'Organization'],
  },
  {
    id: '11',
    title: 'Bank Teller',
    company: 'Community First Bank',
    location: 'Detroit, MI',
    salary: '$18-$20/hr',
    type: 'Full-time',
    description: 'Process transactions and provide excellent customer service. Training provided, advancement opportunities.',
    tags: ['Finance', 'Professional Environment', 'Benefits'],
    matchingSkills: ['Cash Handling', 'Customer Service', 'Attention to Detail'],
  },
  {
    id: '12',
    title: 'Construction Laborer',
    company: 'Detroit Builders Inc',
    location: 'Detroit, MI',
    salary: '$22-$26/hr',
    type: 'Full-time',
    description: 'Join our construction crew building Detroit. No experience required, we provide training and safety equipment.',
    tags: ['Construction', 'Training Provided', 'Great Pay'],
    matchingSkills: ['Physical Fitness', 'Teamwork', 'Willingness to Learn'],
  },
  {
    id: '13',
    title: 'Hotel Front Desk Agent',
    company: 'Downtown Detroit Hotel',
    location: 'Detroit, MI',
    salary: '$16-$18/hr',
    type: 'Full-time',
    description: 'Welcome guests and manage reservations. Evening and weekend shifts available with shift differential.',
    tags: ['Hospitality', 'Flexible Shifts', 'Guest Focused'],
    matchingSkills: ['Customer Service', 'Computer Skills', 'Problem Solving'],
  },
  {
    id: '14',
    title: 'Legal Assistant',
    company: 'Detroit Law Group',
    location: 'Detroit, MI',
    salary: '$38k-$48k/yr',
    type: 'Full-time',
    description: 'Support attorneys with document preparation and client communication. Ideal for those interested in legal field.',
    tags: ['Legal', 'Professional Growth', 'Downtown Location'],
    matchingSkills: ['Written Communication', 'Organization', 'Research'],
  },
  {
    id: '15',
    title: 'Production Assembler',
    company: 'Detroit Manufacturing Corp',
    location: 'Detroit, MI',
    salary: '$19-$22/hr',
    type: 'Full-time',
    description: 'Assemble quality products in a clean, modern facility. Benefits from day one, including health insurance.',
    tags: ['Manufacturing', 'Full Benefits', 'Stable Employment'],
    matchingSkills: ['Hand-Eye Coordination', 'Quality Focus', 'Teamwork'],
  },
];
